import React from 'react';
import AdminGroupListContainer from '@src/components/administration/AdminGroupListContainer';
import { UserGroupTypeEnum } from '@src/model/usergroup/UserGroup';

const AdminUserGroupListPage = () => <AdminGroupListContainer groupType={UserGroupTypeEnum.BASIC} />;

export default AdminUserGroupListPage as any;
